import { Injectable } from '@angular/core';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { GridComponent, PdfExportProperties } from '@syncfusion/ej2-angular-grids';

@Injectable({
  providedIn: 'root'
})
export class DefaulToolbarClickHandlerService {

  constructor() { }

  handle(args: ClickEventArgs, grid: GridComponent) {
    let id: string = grid.element.id;

    if(args.item?.id === id + '_pdfexport' || args.item?.id === 'pdfexport') {
      const pdfExportProperties: PdfExportProperties = {
        pageSize: 'A4',
        pageOrientation: 'Landscape'
      };
      
      grid.pdfExport(pdfExportProperties);
      grid.refreshColumns();
    } else if(args.item?.id === id + '_excelexport' || args.item?.id === 'excelexport') {
  //    console.log('EXPORT TO EXCEL');
    //  let g = new AggregateRowModel();
 //     let gg = grid.aggregates.pop();

      grid.excelExport();
      grid.refreshColumns();

    } else if(args.item?.id === id + '_csvexport' || args.item?.id === 'csvexport') {
      grid.csvExport();
      grid.refreshColumns();
    } 
  }
}
